import { useTranslation } from 'react-i18next'
import { useUpdatePoiMutation } from '@/entities/poi'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface PoiStatusToggleProps {
  poiId: string
  isActive: boolean
}

export function PoiStatusToggle({ poiId, isActive }: PoiStatusToggleProps) {
  const { t } = useTranslation()
  const updateMutation = useUpdatePoiMutation()

  async function handleConfirmed() {
    try {
      await updateMutation.mutateAsync({
        id: poiId,
        payload: { isActive: !isActive },
      })
      showToast.success(t('poi.statusUpdateSuccess'))
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={updateMutation.isPending}
        confirmEnableTitle={t('poi.restoreConfirm')}
        confirmDisableTitle={t('poi.deactivateConfirm', { defaultValue: 'Deactivate this POI?' })}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
